import React from 'react';
import styled, { keyframes } from 'styled-components';
import { WifiOff } from 'lucide-react';
import { usePWA } from '../kmfc-shop/hooks/usePWA';
import { wv } from '../login/LoginScreen';

const slideDown = keyframes`
  from { transform: translateY(-100%); opacity: 0; }
  to   { transform: translateY(0);    opacity: 1; }
`;

const OfflineBar = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 9999;
  animation: ${slideDown} 0.3s ease both;

  background: ${wv.text};
  border-bottom: 1px solid rgba(255,255,255,0.08);

  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px 24px;
`;

const OfflineIcon = styled.div`
  display: flex;
  align-items: center;
  color: ${wv.accent};
  flex-shrink: 0;
`;

const OfflineLabel = styled.span`
  font-family: ${wv.fontSans};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  color: rgba(242,240,235,0.55);
`;

const OfflineMessage = styled.span`
  font-family: ${wv.fontSans};
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.05em;
  color: rgba(242,240,235,0.9);
`;

const OfflineDivider = styled.span`
  width: 1px;
  height: 12px;
  background: rgba(242,240,235,0.15);
  flex-shrink: 0;
`;

const OfflineIndicator = () => {
  const { isOnline } = usePWA();
  if (isOnline) return null;

  return (
    <OfflineBar role="alert" aria-live="assertive">
      <OfflineIcon><WifiOff size={14} strokeWidth={1.75} /></OfflineIcon>
      <OfflineLabel>Offline</OfflineLabel>
      <OfflineDivider />
      <OfflineMessage>Geen internetverbinding — sommige functies zijn beperkt</OfflineMessage>
    </OfflineBar>
  );
};

export default OfflineIndicator;
